import { custom, v1 } from "src/bonzai/bonzai"
import { pickTextAsync } from "src/i18n/usePickText"
import { sendVuplexMessage } from "./sendVuplexMessage"

export const sendOpenProductMessage = async (productId: number) => {
  const [product, playLinks] = await getData(productId)

  sendVuplexMessage({
    type: "OPEN_PRODUCT",
    payload: {
      id: product.id,
      companyId: product.company_id,
      type: product.product_type,
      title: await pickTextAsync(product.titles),
      description: await pickTextAsync(product.descriptions, ""),
      image: product.image,
      link: playLinks.startAppLink ?? product.content_link,
      googlePlayLink: product.google_play_link,
      appStoreLink: product.apple_store_link,
      openExternalBrowser: product.properties.open_external_browser === "true",
    },
  })
}

const getData = (productId: number) => {
  return Promise.all([
    v1.getProduct.fetchQuery([productId], {
      staleTime: Number.POSITIVE_INFINITY,
    }),

    custom.getPlayLinks.fetchQuery([productId], {
      staleTime: Number.POSITIVE_INFINITY,
    }),
  ])
}
